import React, { useState } from "react";
import "../../styles/table-main/main.css";
import "../../styles/sahityik-sanskritik/main.css";

const Main = () => {
    const [activeTab, setActiveTab] = useState("tabClick");

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    return (
        <div id="sahityikSanskritikMain">
            <div id="tableMain">
                <div className="table-main">
                    <div className="container mt-5">
                        <div className="row rounded-1">
                            <ul className="nav nav-tabs  mt-3" id="myTab" role="tablist">
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "tabClick" ? "active" : ""
                                            }`}
                                        onClick={() => handleTabClick("tabClick")}
                                    >
                                        Members &amp; Teams
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "tabClick1" ? "active" : ""
                                            }`}
                                        onClick={() => handleTabClick("tabClick1")}
                                    >
                                        Constitution
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "tabClick2" ? "active" : ""
                                            }`}
                                        onClick={() => handleTabClick("tabClick2")}
                                    >
                                        Events{" "}
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "tabClick3" ? "active" : ""
                                            }`}
                                        onClick={() => handleTabClick("tabClick3")}
                                    >
                                        Campus Notices
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className={`nav-link ${activeTab === "tabClick4" ? "active" : ""
                                            }`}
                                        onClick={() => handleTabClick("tabClick4")}
                                    >
                                        Campus &amp; College Notices
                                    </button>
                                </li>
                            </ul>

                            <div className="tab-content" id="myTabContent">
                                <div
                                    className={`tab-pane fade ${activeTab === "tabClick" ? "show active" : ""
                                        }`}
                                    id="tabClick"
                                ></div>
                                <div
                                    className={`tab-pane fade ${activeTab === "tabClick1" ? "show active" : ""
                                        }`}
                                    id="tabClick1"
                                ></div>
                                <div
                                    className={`tab-pane fade ${activeTab === "tabClick2" ? "show active" : ""
                                        }`}
                                    id="tabClick2"
                                >
                                    <div className="col-md-12 pull-left flip sm-pull-none">
                                        <div className="admin-table">
                                            {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                            <div className="table-scrollable">
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Sno</th>
                                                            <th>Title</th>
                                                            <th>Download</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>01</td>
                                                            <td>
                                                                Inclusion of Proctor in the Literary-Cultural
                                                                Council of CCS University
                                                            </td>
                                                            <td>
                                                                <a
                                                                    href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/1810_%20SSPcommittee_Prof.Beerpal.pdf"
                                                                    className="btn btn-primary btn-download"
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                >
                                                                    Download
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={`tab-pane fade ${activeTab === "tabClick3" ? "show active" : ""
                                        }`}
                                    id="tabClick3"
                                ></div>
                                <div
                                    className={`tab-pane fade ${activeTab === "tabClick4" ? "show active" : ""
                                        }`}
                                    id="tabClick4"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="table-main">
                    <div className="container mt-5 mb-5 admin-container">
                        <div className="row">
                            <div className="col-md-12 pull-left flip sm-pull-none">
                                <div className="admin-table">
                                    <h2 className="my-heading">
                                        Sahityik Sanskritik Parishad Yearly Reports
                                    </h2>
                                    {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                    <div className="table-scrollable">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Sno</th>
                                                    <th>Title</th>
                                                    <th>Download</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>01</td>
                                                    <td>
                                                        Sahityik Sanskritik Parishad Report Year 2023-24{" "}
                                                    </td>
                                                    <td>
                                                        <a
                                                            href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/09/%E0%A4%8F%E0%A4%B8%E0%A4%8F%E0%A4%B8%E0%A4%AA%E0%A5%80_Report_2023final.pdf"
                                                            className="btn btn-primary btn-download"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            Download
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* gallery module */}
                <section className="gallery-main">
                    <div className="container">
                        <h1 className="my-heading mb-3">GALLERY</h1>
                        <ul>
                            {/* 4th module box */}
                            <li>
                                <a
                                    data-bs-toggle="modal"
                                    href="#galleryModal4"
                                    role="button"
                                    className="btn-gallery"
                                >
                                    <img
                                        src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/e0gcsqmemewnukb36ffl.webp"
                                        alt="gallery"
                                    />
                                </a>
                                <a
                                    className="view_more_btn"
                                    data-bs-toggle="modal"
                                    href="#galleryModal4"
                                    role="button"
                                >
                                    View More
                                </a>
                            </li>
                            {/* 3rd module box */}
                            <li>
                                <a
                                    data-bs-toggle="modal"
                                    href="#galleryModal3"
                                    role="button"
                                    className="btn-gallery"
                                >
                                    <img
                                        src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/i2ozyqljgbufhyrrwijk.webp"
                                        alt="gallery"
                                    />
                                </a>
                                <a
                                    className="view_more_btn"
                                    data-bs-toggle="modal"
                                    href="#galleryModal3"
                                    role="button"
                                >
                                    View More
                                </a>
                            </li>
                            {/* 2nd module box */}
                            <li>
                                <a
                                    data-bs-toggle="modal"
                                    href="#galleryModal2"
                                    role="button"
                                    className="btn-gallery"
                                >
                                    <img
                                        src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/1.jpg"
                                        alt="gallery"
                                    />
                                </a>
                                <a
                                    className="view_more_btn"
                                    data-bs-toggle="modal"
                                    href="#galleryModal2"
                                    role="button"
                                >
                                    View More
                                </a>
                            </li>
                            {/* 1st module box */}
                            <li>
                                <a
                                    data-bs-toggle="modal"
                                    href="#galleryModal1"
                                    role="button"
                                    className="btn-gallery"
                                >
                                    <img
                                        src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/th3m77rbaypjqvgylams.webp"
                                        alt="gallery"
                                    />
                                </a>
                                <a
                                    className="view_more_btn"
                                    data-bs-toggle="modal"
                                    href="#galleryModal1"
                                    role="button"
                                >
                                    View More
                                </a>
                            </li>
                        </ul>
                    </div>
                </section>
                {/* 4th module images */}
                <div className="modal-main">
                    <div
                        className="modal fade"
                        id="galleryModal4"
                        aria-hidden="true"
                        aria-labelledby="exampleModalToggleLabel"
                        tabIndex={-1}
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div
                                    id="carousel4"
                                    className="carousel slide"
                                    data-bs-ride="carousel"
                                >
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/e0gcsqmemewnukb36ffl.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/dnjbtgsutljf8fd021wo.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/ekxldqzozwqe3v3blgvt.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/gfccanf4ceyvdzwxkafc.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/igkgsxhzjlyjw00m3lgd.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/jp5ugg2hyvfvnctgwrps.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/nygd14lembbtwn6cyrto.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/ptdprohsslqijof1njlc.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/r5tj4ycqlk0w6dmzfaqs.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/wvkrilyocsacphhaqapb.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/d2fovrcy85suea07mkii.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/fdnibjibkumy1699lhzx.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/mtkwrfinxcq7uhp8ctan.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/pq5i9rffclf5rxmlptgo.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/tk7ofxc0vr0x9fuqxrvd.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/xlevdsszxygyom0kismm.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/ztfebyk7ipxzmybfvefc.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                    </div>
                                    <button
                                        className="carousel-control-prev"
                                        type="button"
                                        data-bs-target="#carousel4"
                                        data-bs-slide="prev"
                                    >
                                        <span
                                            className="carousel-control-prev-icon"
                                            aria-hidden="true"
                                        />
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button
                                        className="carousel-control-next"
                                        type="button"
                                        data-bs-target="#carousel4"
                                        data-bs-slide="next"
                                    >
                                        <span
                                            className="carousel-control-next-icon"
                                            aria-hidden="true"
                                        />
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                    <div className="close-btn-modal">
                                        <button data-bs-dismiss="modal" aria-label="Close">
                                            <i
                                                className="fa fa-times"
                                                aria-hidden="true"
                                                style={{ cursor: "pointer" }}
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* 3rd module images*/}
                <div className="modal-main">
                    <div
                        className="modal fade"
                        id="galleryModal3"
                        aria-hidden="true"
                        aria-labelledby="exampleModalToggleLabel"
                        tabIndex={-1}
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div
                                    id="carousel3"
                                    className="carousel slide"
                                    data-bs-ride="carousel"
                                >
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/i2ozyqljgbufhyrrwijk.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/gejvrtnwnnjzgoa9cyb4.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/eoqqefyrcirpgktp54yl.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/kfnf9sdv2h1droin14fc.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/q8o5bjlqqgqmrobahhxi.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/tujle2vxeql1tis8ispr.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/x8r5vsykvmclddsdgntu.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/xim1uolllhhlx3w5ija8.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                    </div>
                                    <button
                                        className="carousel-control-prev"
                                        type="button"
                                        data-bs-target="#carousel3"
                                        data-bs-slide="prev"
                                    >
                                        <span
                                            className="carousel-control-prev-icon"
                                            aria-hidden="true"
                                        />
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button
                                        className="carousel-control-next"
                                        type="button"
                                        data-bs-target="#carousel3"
                                        data-bs-slide="next"
                                    >
                                        <span
                                            className="carousel-control-next-icon"
                                            aria-hidden="true"
                                        />
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                    <div className="close-btn-modal">
                                        <button data-bs-dismiss="modal" aria-label="Close">
                                            <i
                                                className="fa fa-times"
                                                aria-hidden="true"
                                                style={{ cursor: "pointer" }}
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* 2nd module images*/}
                <div className="modal-main">
                    <div
                        className="modal fade"
                        id="galleryModal2"
                        aria-hidden="true"
                        aria-labelledby="exampleModalToggleLabel"
                        tabIndex={-1}
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div
                                    id="carousel2"
                                    className="carousel slide"
                                    data-bs-ride="carousel"
                                >
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <img
                                                src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/1.jpg"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cultural/1.jpg"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                    </div>
                                    <button
                                        className="carousel-control-prev"
                                        type="button"
                                        data-bs-target="#carousel2"
                                        data-bs-slide="prev"
                                    >
                                        <span
                                            className="carousel-control-prev-icon"
                                            aria-hidden="true"
                                        />
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button
                                        className="carousel-control-next"
                                        type="button"
                                        data-bs-target="#carousel2"
                                        data-bs-slide="next"
                                    >
                                        <span
                                            className="carousel-control-next-icon"
                                            aria-hidden="true"
                                        />
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                    <div className="close-btn-modal">
                                        <button data-bs-dismiss="modal" aria-label="Close">
                                            <i
                                                className="fa fa-times"
                                                aria-hidden="true"
                                                style={{ cursor: "pointer" }}
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* 1st module images */}
                <div className="modal-main">
                    <div
                        className="modal fade"
                        id="galleryModal1"
                        aria-hidden="true"
                        aria-labelledby="exampleModalToggleLabel"
                        tabIndex={-1}
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div
                                    id="carousel1"
                                    className="carousel slide"
                                    data-bs-ride="carousel"
                                >
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/th3m77rbaypjqvgylams.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/uf9p7sth0israxmq2hbi.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/jkkcxkauhyeuleozw4fg.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/mffxogqymo9ajjhvaihh.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/ft75wrmag7x6vzfwg1im.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/d8b9hclrxkc17bbj1po5.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/ubzqgb3gapszprnumpjz.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/qryfo1ck6inth3r2ppyv.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/kxoa0shillwyf4z0hbqt.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                        <div className="carousel-item">
                                            <img
                                                src="https://cdn.ccsuniversity.ac.in/public/webp/2026/06/d8b9hclrxkc17bbj1po5.webp"
                                                className="d-block w-100"
                                                alt="Cultural"
                                            />
                                        </div>
                                    </div>
                                    <button
                                        className="carousel-control-prev"
                                        type="button"
                                        data-bs-target="#carousel1"
                                        data-bs-slide="prev"
                                    >
                                        <span
                                            className="carousel-control-prev-icon"
                                            aria-hidden="true"
                                        />
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button
                                        className="carousel-control-next"
                                        type="button"
                                        data-bs-target="#carousel1"
                                        data-bs-slide="next"
                                    >
                                        <span
                                            className="carousel-control-next-icon"
                                            aria-hidden="true"
                                        />
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                    <div className="close-btn-modal">
                                        <button data-bs-dismiss="modal" aria-label="Close">
                                            <i
                                                className="fa fa-times"
                                                aria-hidden="true"
                                                style={{ cursor: "pointer" }}
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
